import { render, staticRenderFns } from "./DocuformDeleteConfirmationDialog.vue?vue&type=template&id=731c3595"
import script from "./DocuformDeleteConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./DocuformDeleteConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports